export default __webpack_public_path__ + "static/media/logo.616e5aac.svg";